module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_fails.js
// module id = 594
// module chunks = 0